import { makeListGroupsComponent } from '../ListGroups';
import { TimelineCardEvent } from '../TimelineListItem/types';

export const TimelineEventListGroups = makeListGroupsComponent<
    TimelineCardEvent,
    { showDeviceName?: boolean; showPath?: boolean; showBadges?: boolean }
>();
